import ActionTypes from '../actionTypes';
import Actions from '../Actions';
import { NotificationsState } from './types';
import { StateStatus } from '../../enums/StateStatus';

export const defaultNotificationsState: NotificationsState = {
  notifications: null,
  notificationTypes: null,
  status: StateStatus.Initial,
  error: null
};

export default function reducer(state: NotificationsState = defaultNotificationsState, action: Actions): NotificationsState {
  switch (action.type) {
    case ActionTypes.GET_NOTIFICATIONS:
    case ActionTypes.GET_NOTIFICATION_TYPES:
    case ActionTypes.SAVE_NOTIFICATION_TYPE:
      return { ...state, status: StateStatus.Busy, error: null };
    case ActionTypes.GET_NOTIFICATIONS_SUCCESS:
      return { ...state, notifications: action.payload, status: StateStatus.Loaded };
    case ActionTypes.GET_NOTIFICATION_TYPES_SUCCESS:
      return { ...state, notificationTypes: action.payload, status: StateStatus.Loaded };
    case ActionTypes.SAVE_NOTIFICATION_TYPE_SUCCESS:
      return { ...state, status: StateStatus.Loaded };
    case ActionTypes.GET_NOTIFICATIONS_ERROR:
    case ActionTypes.GET_NOTIFICATION_TYPES_ERROR:
    case ActionTypes.SAVE_NOTIFICATION_TYPE_ERROR:
      return { ...state, error: action.payload, status: StateStatus.Error };
    default:
      return state;
  }
}
